import React, { useEffect, useState } from "react";
import { Message } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";

import {
    loadUploadedDocuments,
    removeDocument,
    webCamUpload,
    showDocumentUploadForm,
} from "./actions";
import WebcamUpload from "./webcam/webcam-upload";
import DocumentUpload from "./document-upload";
import AddNoteModal from "./add-note.modal";
import { InvoiceDocumentTable } from "./table.component";

const DocumentContainer = ({ invoiceId }) => {
    const [attemptedLoading, setAttemptedLoading] = useState(false);
    const [showNoteModal, setShowNoteModal] = useState(false);

    const dispatch = useDispatch();
    const {
        uploadError,
        openWebCam,
        documentUploadForm,
        uploadingDocument,
        documents,
        notes,
        removeError,
        removingDocumentsId,
        isLoading,
        error,
        file,
    } = useSelector(({ invoiceDocument }) => invoiceDocument);

    useEffect(() => {
        if (invoiceId && !isLoading && !attemptedLoading) {
            setAttemptedLoading(true);
            dispatch(loadUploadedDocuments(invoiceId));
        }
    }, [invoiceId, isLoading, attemptedLoading, dispatch]);

    const removeDocumentWhenConfirmed = id => dispatch(removeDocument(id));

    const errorMessage = (errorState, errorType) =>
        !isLoading &&
        errorState && (
            <Message error content={errorState} header={`Error ${errorType} Documents`} />
        );

    return (
        <>
            {errorMessage(uploadError, "Uploading")}
            {errorMessage(removeError, "Removing")}
            {errorMessage(error, "Loading")}
            {!!openWebCam && <WebcamUpload />}
            {!!documentUploadForm && !!file && <DocumentUpload />}
            <AddNoteModal
                invoiceId={invoiceId}
                open={showNoteModal}
                onDismissModal={() => setShowNoteModal(false)}
            />
            <InvoiceDocumentTable
                isLoading={isLoading}
                documents={documents}
                notes={notes}
                uploadingDocument={uploadingDocument}
                removingDocumentsId={removingDocumentsId}
                removeDocumentWhenConfirmed={removeDocumentWhenConfirmed}
                invoiceId={invoiceId}
                handleFileUploadClick={e => {
                    if (!e.target.files.length) {
                        return;
                    }

                    dispatch(
                        showDocumentUploadForm({
                            documentUploadForm: true,
                            invoiceId,
                            file: e.target.files[0],
                        })
                    );
                }}
                handleCameraUploadClick={() =>
                    dispatch(webCamUpload({ openWebCam: true, invoiceId }))
                }
                showNoteModal={() => setShowNoteModal(true)}
            />
        </>
    );
};

export default DocumentContainer;
